import BoxWidget from '@/components/box-widget/BoxWidget.vue';
import Comment from '@/gotu-vue-common/src/components/timeline/events/comment/Comment.vue';

export default {
  props: {
    comment: Object,
  },
  components: {
    'box-widget': BoxWidget,
    comment: Comment,
  },
};



// WEBPACK FOOTER //
// ./src/components/lab/single-comment-box/SingleCommentBox.js